import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  static values = {
    event: String,
    params: Object
  }

  track(event) {
    if (window.analytics && this.hasEventValue) {
      window.analytics.track(this.eventValue, this.paramsValue || {});
    }
  }
}
